import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useCreateBundle } from '../../../hooks/inventory/useCreateBundle';
import { useUpdateBundle } from '../../../hooks/inventory/useUpdateBundle';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';

export default function BundleForm({ successCallback = null, bundle = null, mode = "create", open, onClose }) {

    const { t } = useTranslation('common'); 

    const [name, setName] = React.useState(bundle ? bundle.name : "");

    const { create } = useCreateBundle(successCallback);
    const { update } = useUpdateBundle(successCallback);

    const { showSnackbar } = useSnackbar();

    React.useEffect(() => {
        // reset field when there are changes (e.g. when opening edit)
        setName(bundle ? bundle.name : "");
    }, [bundle, open]);

    const handleSave = async () => {
        if (!name.trim()) {
            showSnackbar(t('inventory.bundles.messages.name_required'), "warning");
            return;
        }

        try 
        {
            if (mode === "create") {
                await create({ 
                    name: name
                });
                showSnackbar(t('inventory.bundles.messages.create_success'), "success");
                handleCancel();
            } else if (mode === "edit" && bundle) {
                await update(bundle.id, { 
                    name: name
                 });
                showSnackbar(t('inventory.bundles.messages.update_success'), "success");
                handleCancel();
            }
            setName("");
        } catch (err) {
            showSnackbar(t('inventory.bundles.messages.save_fail'), "error");
        }

    };

    const handleCancel = () => {
        setName("");
        onClose();
    };

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>{mode === "create" ? "Add Bundle" : "Edit Bundle"}</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
            <TextField
                label="Bundle Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
            />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>
                Save
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}